import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Popover } from "@material-ui/core";
import { InfoIcon } from "../../icons";
import PendingCriticalPartsPopup from "./PendingCriticalPartsPopup";

const CriticalMaterialIndicator = ({
  pendingParts,
  vc,
  fontSize = "1.5em",
  style = {},
}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const iconRef = useRef(null);

  return (
    <>
      <InfoIcon
        ref={iconRef}
        style={{
          color: "#F17C7C",
          fontSize,
          cursor: "pointer",
          ...style,
        }}
        onClick={() => setIsPopupOpen(true)}
      />

      <Popover
        open={isPopupOpen}
        anchorEl={iconRef.current}
        onClose={() => setIsPopupOpen(false)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
      >
        <PendingCriticalPartsPopup vc={vc} pendingParts={pendingParts} />
      </Popover>
    </>
  );
};

CriticalMaterialIndicator.propTypes = {
  vc: PropTypes.string.isRequired,
  pendingParts: PropTypes.arrayOf(
    PropTypes.shape({
      partNumber: PropTypes.string.isRequired,
    }),
  ).isRequired,
  fontSize: PropTypes.string,
  style: PropTypes.object,
};

export default CriticalMaterialIndicator;
